import { render } from "./CommLogCard.vue?vue&type=template&id=35af38e0"
import script from "./CommLogCard.vue?vue&type=script&lang=js"
export * from "./CommLogCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__